var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendSolid = function SvgSendSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.706 1.255a.75.75 0 0 0-.96-.96l-18 6.5a1.3 1.3 0 0 0-.072 2.38l6.06 3.03L16.97 2.97a.75.75 0 1 1 1.06 1.06l-9.235 9.236 3.03 6.06a1.3 1.3 0 0 0 2.381-.071l6.5-18Z",
    fill: "currentColor"
  })));
};
export default SvgSendSolid;